module.exports = __webpack_public_path__ + "images/03cf50543d12b7bd0be2cb2b7ef32c26.png";